import { useCampaignCapabilitiesStore } from '@discovr/features';
import type { RosterRowRef } from '@discovr/features';

interface BrandSafetyTabProps {
  creator: RosterRowRef;
}

export function BrandSafetyTab({ creator }: BrandSafetyTabProps) {
  const { renderEmbeddedBrandSafetyAgent } = useCampaignCapabilitiesStore();

  if (!renderEmbeddedBrandSafetyAgent) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">
        <p className="text-body-sm-medium">Brand safety analysis not available.</p>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-[calc(100vh-320px)] flex-col">
      {renderEmbeddedBrandSafetyAgent(creator as Record<string, unknown>)}
    </div>
  );
}
